import { useImpersonationCacheInvalidation } from "@/hooks/use-impersonation";

// ADV-1460: a render-less sync that flushes the React Query cache whenever the
// impersonated business changes in any tab. Mounted ONCE at the app root
// (above the router) so it covers every protected route tree — the main app
// shell (AppLayoutV2, `/`) AND the settings shell (V2SettingsLayout,
// `/settings/*`), which are sibling layouts, not nested. Mounting it here
// instead of inside `useImpersonation` also avoids the per-consumer listener
// fan-out (e.g. /settings/adva/account-users calls `useImpersonation` once per
// user row). Registering a window `storage` listener is inert on public routes
// where the cache is empty, so it needs no auth gating.
export function ImpersonationCacheSync(): null {
  useImpersonationCacheInvalidation();
  return null;
}
